import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";

const dataAPI = createSlice({
    name: 'data',
    initialState: {
        representation: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRepresentation.pending, (state, action) => {
                state.representationLoading = true;
                state.valid_to = Date.now() + 1000 * 60 * 60; // 1 Hour
            })
            .addCase(fetchRepresentation.fulfilled, (state, action) => {
                state.representation = action.payload;
                state.valid_to = Date.now() + 1000 * 60 * 60; // 1 Hour
                state.error = undefined;
                state.representationLoading = false;

            })
            .addCase(fetchRepresentation.rejected, (state, action) => {
                state.valid_to = Date.now() + 1000 * 60 * 10; // 1 Hour
                state.representationLoading = false;
            })
    }
});

export const fetchRepresentation = createAsyncThunk(
    "data/fetch/representation",
    async () => {
        const response = await apiClient.get(`/api/v1/data/representation`);
        return response.data
    }
);

export default dataAPI.reducer;
